import { render } from "./form-flat.vue?vue&type=template&id=79321814&scoped=true"
import script from "./form-flat.vue?vue&type=script&lang=js"
export * from "./form-flat.vue?vue&type=script&lang=js"

import "./form-flat.vue?vue&type=style&index=0&id=79321814&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79321814"]])

export default __exports__